<script setup lang="ts">
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Navigation } from "vue3-carousel";

interface Props {
    slides: Array<{ title: string; image: string; link: string; description: string }>;
    translations: { read_more: string };
}

const props = defineProps<Props>();

const breakpoints = {
    1: {
        itemsToShow: 1.25,
    },
    768: {
        itemsToShow: 2.1,
    },
    1024: {
        itemsToShow: 2.5,
    },
};
</script>

<template>
    <carousel :breakpoints="breakpoints" snap-align="start" :gap="20">
        <template #addons>
            <div class="absolute right-0 top-0 hidden md:block">
                <div class="relative flex items-center h-[2.9375rem]">
                    <navigation />
                </div>
            </div>
        </template>
        <slide v-for="slide in slides" :key="slide" class="flex-col !justify-start">
            <component :is="slide.link ? 'a' : 'div'" :href="slide.link" class="flex group flex-col text-left justify-start w-full gap-5">
                <div class="relative rounded-[4px] overflow-hidden w-full self-stretch aspect-[16/9]">
                    <img :src="slide.image" :alt="slide.title" class="object-center object-cover absolute inset-0 w-full h-full duration-700 group-hover:scale-110 transition-transform" />
                </div>
                <h2 class="text-h5 text-primary">{{ slide.title }}</h2>
                <div class="custom-prose w-full [&_p]:text-sm" v-html="slide.description"></div>
                <div v-if="slide.link" class="inline-flex items-center gap-2 text-md font-medium text-primary">
                    {{ translations.read_more }}
                    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-[1.125rem] w-[1.125rem] -rotate-90 transition-transform duration-500 group-hover:translate-x-1">
                        <path d="m6 9 6 6 6-6" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path>
                    </svg>
                </div>
            </component>
        </slide>
    </carousel>
</template>

<style scoped>
.carousel {
    position: static;
}

:deep(.carousel__viewport) {
    overflow: visible;
    margin: 0 -10px;
}

.carousel__slide {
    padding: 10px;
}

:deep(.carousel__prev),
:deep(.carousel__next) {
    position: relative;
    box-sizing: content-box;
    transform: none;
    top: unset;
    left: unset;
    right: unset;
    @apply text-primary;
}
</style>
